/* Keep the PDP floating cart shortcut at its normal size while the page is pinch-zoomed. */
const floatingCart = document.querySelector('.hn-floating-cart');
const viewport = window.visualViewport;

if (floatingCart && viewport) {
  const sync = () => {
    floatingCart.style.setProperty('--hn-floating-cart-viewport-scale', String(1 / (viewport.scale || 1)));
  };
  viewport.addEventListener('resize', sync, { passive: true });
  viewport.addEventListener('scroll', sync, { passive: true });
  sync();
}
